import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import classNames from 'classnames'

import Accueil from './icons/HomeIcon'

import TransfertIcon from './icons/TransfertIcon'
import RechargeIcon from './icons/RechargeIcon'

import SignOutIcon from '../assets/SignOutIcon.svg'
import frameDashboard from '../assets/frameDashboard.svg'
import ModalLogOutContainer from 'containers/logOutContainer/modalLogOutContainer'

import TransfertCompteBancaireIcon from './icons/TransfertCompteBancaireIcon'
import BeneficiaryIcon from './icons/BeneficiaryIcon'
import logoMyEasy from '../assets/logoMyEasy.svg'
import HistoriqueIcon from './icons/HistoriqueIcon'
import RechargeCartePrepayeeIcon from './icons/rechargeCartePrepayeeIcon'
import TransfertWalletIcon from './icons/TransfertWalletIcon'
import AssuranceLocale from './icons/assuranceLocale'
import PaimentFactureIcon from './icons/PaimentFactureIcon'
import { useTranslation } from 'react-i18next'

export default function SideBar() {
  const Navigate = useNavigate()
  const {t}= useTranslation()

  const location = useLocation()
  const navigate = useNavigate()
  const [openModalLogOut, setOpenModalLogOut] = useState(false)

  const closeModal = () => {
    setOpenModalLogOut(false)
  }

  const Links: {
    img: string | React.ElementType
    name: string
    link: string
    border? : boolean
  }[] = [
      {
        img: Accueil,
        name: t("ServiceList.home"),
        link: '/',
        border: true
      },
     
      {
        img: PaimentFactureIcon,
        name: t("ServiceList.billPayment"),
        link: '/paimentFacture',
      },

      {
        img: TransfertIcon,
        name: t("ServiceList.cashTransfer"),
        link: '/transfert/0',
      },

      {
        img: TransfertCompteBancaireIcon,
        name: t("ServiceList.bankTransfer"),
        link: '/transfert/1',
      },
      {
        img: TransfertWalletIcon,
        name: t("ServiceList.walletTransfer"),
        link: '/transfert-vers-wallet',
      },
      {
        img: RechargeCartePrepayeeIcon,
        name: t("ServiceList.prepaidCardRecharge"),
        link: '/rechargeCartePrepayee',
      },

      {
        img: RechargeIcon,
        name: t("ServiceList.mobileRecharge"),
        link: '/recharge',
      },

      {
        img: AssuranceLocale,
        name: t("ServiceList.localInsurance"),
        link: '/assurance',
        border: true

      },
     
      {
        img: BeneficiaryIcon,
        name: t("ServiceList.beneficiaries"),
        link: '/beneficiary',
      },
       {
        img: HistoriqueIcon ,
        name: t("ServiceList.history"),
        link: '/history',
      },
    ]

  return (
 

    <div className={`lg:hidden w-[310px]  xl:w-[280px] top-[40px] overflow-y-auto max-h-screen fixed border-r-[1px] overflow-hidden    border-[#E2E2FB]`}
      style={{ scrollbarWidth: 'none' }}>

      <div className='w-[310px] xl:w-[280px] border-r-[1px] pl-[30px] xl:pl-[20px] h-[80px]  border-[#E2E2FB]  bg-white fixed flex items-center '>
        <img className="hover:cursor-pointer " width={149} height={54} src={logoMyEasy} onClick={() => { Navigate('/') }} />
      </div>
      <div className=" flex flex-col  mt-[120px]">
        {Links.map((item, index) => {
          const ImageComponent = item.img
          return (
            <Link
              to={item.link}
              key={index}
              className={`  flex gap-[16px]   items-center justify-between transition duration-200 group ${location.pathname === item.link && 'bg-[#F1F1FF] w-full'}`}
            >
              <div className=' flex flex-col  mr-4 ml-[30px] xl:ml-[20px] w-[250px]'>
                <div className={`  flex h-[56px] gap-4 items-center `}>

                  <div className='w-[25px] h-[25px]'>
                    <ImageComponent strokeColor={`${location.pathname === item.link ? 'stroke-[#5754E5] group-hover:stroke-[#4D36CC] ' : 'stroke-[#AEB6FB] group-hover:stroke-[#8F99EF]'}`} />
                  </div>

                  <div
                    className={classNames(
                      location.pathname === item.link ? 'text-[#5754E5] group-hover:text-[#4D36CC] ' : 'text-[#AEB6FB] group-hover:text-[#8F99EF]  ',
                      ' text-[16px] xl:text-[14px] font-semibold ',
                    )}
                  >
                    {item.name}
                  </div>
                </div>
                {item.border && <div className='h-[1px] w-[240px] bg-[#E2E2FB] '/>}
              </div>
              {location.pathname === item.link && <div className='bg-[#5754E5] h-[30px] rounded-l-md place-content-end w-1 ' />}
            </Link>
          )
        })}

      </div>

      <img className="hover:cursor-pointer pl-[30px]" src={frameDashboard} onClick={() => { navigate('/settingProfile/1') }} />

      <div
        className=" flex gap-[16px] items-center pl-[30px] h-[60px] hover:cursor-pointer mb-10"
        onClick={() => { setOpenModalLogOut(true) }}>
        <img src={SignOutIcon} alt="" />
        <div className="text-[#5754E5] text-[17px]  font-semibold">{t("ServiceList.logout")}</div>
      </div>
      <ModalLogOutContainer isOpen={openModalLogOut} closeModal={closeModal} openModalLogOut={openModalLogOut} />

    </div>
  )
}

